import { type CallProvider } from 'hooks/phones/types';
import { ChannelType } from 'src/api/generated';
import STATES from 'states/index';

export interface QuickPhoneState {
  isLoading: boolean;
  hasError: boolean;
  isReady: boolean;
  isDisabled: boolean;
}

export const getQuickPhoneState = (
  callProvider: Pick<CallProvider, 'loading' | 'error'> | null,
  phoneState: string
): QuickPhoneState => {
  if (!callProvider) {
    return {
      isLoading: false,
      hasError: false,
      isReady: false,
      isDisabled: true,
    };
  }

  return {
    isLoading: callProvider.loading,
    hasError: !!callProvider.error,
    isReady: phoneState === STATES.PHONE.READY,
    isDisabled:
      phoneState === STATES.PHONE.ESTABLISHED ||
      phoneState === STATES.PHONE.OUTGOING ||
      phoneState === STATES.PHONE.INCOMING ||
      phoneState === STATES.PHONE.OFFLINE ||
      phoneState === STATES.PHONE.ERROR,
  };
};

export const isActionDisabled = (
  channelType: ChannelType,
  phoneState: QuickPhoneState
): boolean => {
  if (
    channelType !== ChannelType.PHONE &&
    channelType !== ChannelType.WHATSAPP
  ) {
    return false;
  }

  return (
    phoneState.isLoading ||
    phoneState.hasError ||
    !phoneState.isReady ||
    phoneState.isDisabled
  );
};

export const getActionTooltip = (
  channelType: ChannelType,
  phoneState: QuickPhoneState,
  isValidNumber: boolean
): string | undefined => {
  if (
    channelType !== ChannelType.PHONE &&
    channelType !== ChannelType.WHATSAPP
  ) {
    return undefined;
  }

  // TODO: check when implementing i18n
  if (phoneState.isLoading) return 'Cargando teléfono...';
  if (phoneState.hasError) {
    return 'Ocurrió un error al cargar el teléfono';
  }
  if (phoneState.isDisabled) {
    return 'Teléfono no disponible';
  }
  if (!phoneState.isReady) {
    return 'Teléfono no listo';
  }
  if (isValidNumber) {
    return 'Llamar';
  } else {
    return 'Número no válido. Arréglalo para realizar llamadas.';
  }
};
